import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '@store/hooks';
import { Form } from 'react-bootstrap';
import useGetCategoriesList from '@hooks/INV/useGetCategoriesList';
import { AddMasterItemsINV, GetMasterItemsList, getNewItemBarcode } from '@store/INV/MasterItems/MasterItemsSlice';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import useGetUnitsOfMeasureList from '@hooks/INV/useGetUnitsOfMeasureList';
import useLookupGetItemType from '@hooks/Lookups/use-Lookup-GetItemType';
import { MasterItemsSchema } from '../../../ValidationForm/validationSchema';
import useGetBrandList from '@hooks/INV/Brand/useGetBrandList';
import Loading from '@components/Shared/Loader/Loading';
import { useState } from 'react';
import { Card, CardBody } from '@components/card/card';
import useLookupGetExpenseDistribute from '@hooks/Lookups/use-Lookup-GetExpenseDistribute';
import useGetTaxCategory from '@hooks/Lookups/use-Get_TaxCategory';

//__________________________________________________________________________________________________

const AddMasterItems = ({ onclose, openModalEdit, setItem }: any) => {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();

  const [loadBarcode, setLoadBarcode] = useState(false);

  const { CategoriesList, loading: loading1 } = useGetCategoriesList();
  const { UnitsOfMeasureList, loading: loading2 } = useGetUnitsOfMeasureList();
  const { ITEM_TYPE, loading: loading3 } = useLookupGetItemType();
  const { BrandListOptions, loading: loading4 } = useGetBrandList();
  const { ExpenseDistribute, loading: loading5 } = useLookupGetExpenseDistribute();
  const { TaxCategory, loading: loading6 } = useGetTaxCategory();

  const [activeTab, setActiveTab] = useState('basic');

  // دالة توليد باركود من السيرفر
  const generateBarcode = async () => {
    try {
      setLoadBarcode(true);
      const res = await dispatch(getNewItemBarcode()).unwrap();
      if (res.succeeded === true) {
        formik.setFieldValue('barcode', res.data);
      } else {
        formik.setFieldValue('barcode', '0');
      }
    } catch (error) {
      formik.setFieldValue('barcode', '0');
    } finally {
      setLoadBarcode(false);
    }
  };
  const formik = useFormik({
    initialValues: {
      id: '',
      itemCode: '',
      barcode: '',
      name: '',
      name2: '',
      brandId: '',
      displayName: '',
      displayName2: '',
      categoryId: '',
      itemType: 'InventoryItem',
      // serviceItemFlag: false,
      isActive: true,
      purchasingEnabledFlag: true,
      customerOrderEnabledFlag: true,
      internalOrderEnabledFlag: true,
      soTransactionsFlag: false,
      invTransactionsEnabledFlag: false,
      authorizeNegativeStock: true,
      salesPrice: '0',
      purchasePrice: '0',
      unitOfMeasure: '',
      image: '',
      demandTimeUp: '0',
      demandTimeDown: '0',
      description: '',
      discountRate: '0',
      expenseDistribute: '',
      taxCategory: 'STANDARD'
    },

    validationSchema: MasterItemsSchema(t),

    onSubmit: values => {
      dispatch(
        AddMasterItemsINV({
          id: null,
          itemCode: values.itemCode,
          barcode: values.barcode,
          name: values.name,
          name2: values.name2,
          displayName: values.displayName,
          displayName2: values.displayName2,
          categoryId: values.categoryId,
          brandId: values.brandId || null,
          itemType: values.itemType,
          // serviceItemFlag: values.serviceItemFlag,
          isActive: values.isActive,
          purchasingEnabledFlag: values.purchasingEnabledFlag,
          customerOrderEnabledFlag: values.customerOrderEnabledFlag,
          internalOrderEnabledFlag: values.internalOrderEnabledFlag,
          soTransactionsFlag: values.soTransactionsFlag,
          invTransactionsEnabledFlag: values.invTransactionsEnabledFlag,
          authorizeNegativeStock: values.authorizeNegativeStock,
          salesPrice: values.salesPrice || 0,
          purchasePrice: values.purchasePrice || 0,
          unitOfMeasure: values.unitOfMeasure,
          image: values.image,
          demandTimeUp: values.demandTimeUp || 0,
          demandTimeDown: values.demandTimeDown || 0,
          description: values.description,
          discountRate: values.discountRate || 0,
          taxCategory: values.taxCategory,
          expenseDistribute: values.itemType === 'ExpenseItem' ? values.expenseDistribute : ''
        })
      )
        .unwrap()
        .then(res => {
          if (res.succeeded === true) {
            setItem(res.data);
            onclose();
            openModalEdit();
            dispatch(GetMasterItemsList());
            CustomAlert({ action: 'Add' });
          } else {
            CustomAlert({ action: 'Error' });
          }
        })
        .catch(error => {
          CustomAlert({ action: 'Error' });
        })
        .finally(() => formik.setSubmitting(false));
    }
  });

  const fieldNames: Record<string, string> = {
    name2: t('LocalName'),
    purchasePrice: t('PurchasePrice'),
    salesPrice: t('SalesPrice'),
    name: t('GlobalName'),
    itemCode: t('ItemCode'),
    categoryId: t('ItemCategory'),
    barcode: t('Barcode'),
    itemType: t('ItemType'),
    unitOfMeasure: t('UnitOfMeasure'),

    demandTimeUp: t('UpperDemandLimit'),
    demandTimeDown: t('LowerDemandLimit'),
    expenseDistribute: t('DistributionMethod')
  };

  return (
    <>
      <Form onSubmit={formik.handleSubmit}>
        <Loading loading={loading1 || loading2 || loading3 || loading4 || loading5 || loading6}>
          <Card className='mb-0 p-3 shadow-sm'>
            <div className=''>
              <h4>
                <i className='fas fa-cube me-2 text-theme'></i> {t('AddNewItem')}
              </h4>
              <p className='mb-0'>{t('FillBasicItemDataToAddToInventory')}</p>
            </div>
          </Card>

          <div className='p-3 '>
            <ul className='nav nav-tabs mb-4' role='tablist'>
              <li className='nav-item'>
                <button
                  className={`nav-link ${activeTab === 'basic' ? 'active' : ''}`}
                  onClick={() => setActiveTab('basic')}
                  type='button'
                >
                  <i className='fas fa-info-circle me-2'></i>
                  {t('BasicInformation')}
                </button>
              </li>
              <li className='nav-item'>
                <button
                  className={`nav-link ${activeTab === 'pricing' ? 'active' : ''}`}
                  onClick={() => setActiveTab('pricing')}
                  type='button'
                >
                  {/* <i className='fas fa-tag me-2'></i>
                  {t('Pricing')} */}
                  <i className='fas fa-cog me-2'></i> {t('ItemSettings')}
                </button>
              </li>
            </ul>

            <div className='row'>
              <div className='col-xl-12'>
                <div className={`tab-pane ${activeTab === 'basic' ? 'show active' : 'd-none'}`}>
                  <Card>
                    <div className='card-header bg-light bg-opacity-30'>
                      <h5 className='mb-0'>
                        <i className='fas fa-info-circle me-2'></i>
                        {t('BasicInformation')}
                      </h5>
                    </div>

                    <CardBody>
                      <div className='row'>
                        <div className='col-xl-6'>
                          <div className='form-group mb-3'>
                            <label className='form-label required-field'>{t('LocalName')}</label>
                            <Form.Control
                              autoComplete='off'
                              className='form-control'
                              type='text'
                              name='name2'
                              onChange={formik.handleChange}
                              value={formik.values.name2}
                              isInvalid={!!(formik.touched.name2 && formik.errors.name2)}
                              placeholder={t('EnterLocalName')}
                            />
                            <Form.Control.Feedback type='invalid'>{formik.errors.name2}</Form.Control.Feedback>
                          </div>
                        </div>
                        <div className='col-xl-6'>
                          <div className='form-group mb-3'>
                            <label className='form-label required-field'>{t('GlobalName')}</label>
                            <Form.Control
                              autoComplete='off'
                              className='form-control'
                              type='text'
                              name='name'
                              onChange={formik.handleChange}
                              value={formik.values.name}
                              isInvalid={!!(formik.touched.name && formik.errors.name)}
                              placeholder={t('EnterGlobalName')}
                            />
                            <Form.Control.Feedback type='invalid'>{formik.errors.name}</Form.Control.Feedback>
                          </div>
                        </div>

                        <div className='col-xl-6'>
                          <label className='form-label'>{t('Barcode')}</label>
                          <div className='input-group flex-nowrap'>
                            <span className='input-group-text'>
                              <i className='fas fa-barcode'></i>
                            </span>
                            <Form.Control
                              autoComplete='off'
                              className='form-control'
                              type='text'
                              name='barcode'
                              onChange={formik.handleChange}
                              value={formik.values.barcode}
                              isInvalid={!!(formik.touched.barcode && formik.errors.barcode)}
                              placeholder={t('EnterBarcode')}
                            />

                            <button
                              type='button'
                              className='btn btn-outline-secondary'
                              onClick={generateBarcode}
                              title={t('GenerateBarcode')}
                            >
                              {loadBarcode ? (
                                <div className='spinner-border spinner-border-sm'></div>
                              ) : (
                                <i className='fa fa-magic'></i>
                              )}
                            </button>
                          </div>
                        </div>

                        <div className='col-xl-6'>
                          <div className='form-group mb-3'>
                            <label className='form-label required-field'>{t('ItemCode')}</label>
                            <Form.Control
                              autoComplete='off'
                              className='form-control'
                              type='text'
                              name='itemCode'
                              onChange={formik.handleChange}
                              value={formik.values.itemCode}
                              isInvalid={!!(formik.touched.itemCode && formik.errors.itemCode)}
                              placeholder={t('EnterItemCode')}
                            />
                            <Form.Control.Feedback type='invalid'>{formik.errors.itemCode}</Form.Control.Feedback>
                          </div>
                        </div>

                        <div className='col-xl-6'>
                          <div className='form-group mb-3'>
                            <label className='form-label required-field'>{t('ItemCategory')}</label>
                            <Form.Select
                              className='form-select'
                              name='categoryId'
                              onChange={formik.handleChange}
                              value={formik.values.categoryId}
                              isInvalid={!!(formik.touched.categoryId && formik.errors.categoryId)}
                            >
                              <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                              {CategoriesList &&
                                CategoriesList?.map((item, idx) => (
                                  <option key={++idx} value={item.id}>
                                    {i18n.language === 'en' ? item.name : item.name2}
                                  </option>
                                ))}
                            </Form.Select>
                            <Form.Control.Feedback type='invalid'>{formik.errors.categoryId}</Form.Control.Feedback>
                          </div>
                        </div>

                        <div className='col-xl-6'>
                          <div className='form-group mb-3'>
                            <label className='form-label'>{t('Brand')}</label>
                            <Form.Select
                              className='form-select'
                              name='brandId'
                              onChange={formik.handleChange}
                              value={formik.values.brandId}
                              isInvalid={!!(formik.touched.brandId && formik.errors.brandId)}
                            >
                              <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                              {BrandListOptions &&
                                BrandListOptions?.map((item, idx) => (
                                  <option key={++idx} value={item.value}>
                                    {item.label}
                                  </option>
                                ))}
                            </Form.Select>
                            <Form.Control.Feedback type='invalid'>{formik.errors.brandId}</Form.Control.Feedback>
                          </div>
                        </div>

                        <div className='col-xl-6'>
                          <div className='form-group mb-3'>
                            <label className='form-label required-field'>{t('UnitOfMeasure')}</label>
                            <Form.Select
                              className='form-select'
                              name='unitOfMeasure'
                              onChange={formik.handleChange}
                              value={formik.values.unitOfMeasure}
                              isInvalid={!!(formik.touched.unitOfMeasure && formik.errors.unitOfMeasure)}
                            >
                              <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                              {UnitsOfMeasureList &&
                                UnitsOfMeasureList?.map((item, idx) => (
                                  <option key={++idx} value={item.id}>
                                    {i18n.language === 'en' ? item.name : item.name2}
                                  </option>
                                ))}
                            </Form.Select>
                            <Form.Control.Feedback type='invalid'>{formik.errors.unitOfMeasure}</Form.Control.Feedback>
                          </div>
                        </div>
                        <div className={formik.values.itemType === 'ExpenseItem' ? 'col-xl-3' : 'col-xl-6'}>
                          <div className='form-group mb-3'>
                            <label className='form-label required-field'>{t('ItemType')}</label>
                            <Form.Select
                              className='form-select'
                              name='itemType'
                              onChange={formik.handleChange}
                              value={formik.values.itemType}
                              isInvalid={!!(formik.touched.itemType && formik.errors.itemType)}
                            >
                              <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                              {ITEM_TYPE &&
                                ITEM_TYPE?.map((item: any, idx: number) =>
                                  item.list?.map((list: any) => (
                                    <option key={++idx} value={list.lookupCode}>
                                      {i18n.language === 'ar' ? list.meaning2 : list.meaning}
                                    </option>
                                  ))
                                )}
                            </Form.Select>
                            <Form.Control.Feedback type='invalid'>{formik.errors.itemType}</Form.Control.Feedback>
                          </div>
                        </div>
                        {formik.values.itemType === 'ExpenseItem' && (
                          <div className='col-xl-3'>
                            <div className='form-group mb-3'>
                              <label className='form-label required-field'>{t('DistributionMethod')}</label>
                              <Form.Select
                                className='form-select'
                                name='expenseDistribute'
                                onChange={formik.handleChange}
                                value={formik.values.expenseDistribute}
                                isInvalid={!!(formik.touched.expenseDistribute && formik.errors.expenseDistribute)}
                              >
                                <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                                {ExpenseDistribute &&
                                  ExpenseDistribute?.map((item: any, idx: number) =>
                                    item.list?.map((list: any) => (
                                      <option key={++idx} value={list.lookupCode}>
                                        {i18n.language === 'ar' ? list.meaning2 : list.meaning}
                                      </option>
                                    ))
                                  )}
                              </Form.Select>
                              <Form.Control.Feedback type='invalid'>{formik.errors.itemType}</Form.Control.Feedback>
                            </div>
                          </div>
                        )}
                      </div>
                    </CardBody>
                  </Card>
                </div>

                <div className={`tab-pane ${activeTab === 'pricing' ? 'show active' : 'd-none'}`}>
                  <div className='row'>
                    <div className='col-8'>
                      <Card>
                        <div className='card-header bg-light bg-opacity-30'>
                          <h5 className='mb-0'>
                            <i className='fas fa-tag me-2'></i>
                            {t('Pricing')}
                          </h5>
                        </div>

                        <CardBody>
                          <div className='row'>
                            <div className='col-xl-6'>
                              <div className='form-group mb-3'>
                                <label className='form-label'>{t('SalesPrice')}</label>
                                <Form.Control
                                  autoComplete='off'
                                  className='form-control'
                                  type='number'
                                  min='0'
                                  step='0.01'
                                  name='salesPrice'
                                  onChange={formik.handleChange}
                                  value={formik.values.salesPrice}
                                  isInvalid={!!(formik.touched.salesPrice && formik.errors.salesPrice)}
                                />
                                <Form.Control.Feedback type='invalid'>{formik.errors.salesPrice}</Form.Control.Feedback>
                              </div>
                            </div>
                            <div className='col-xl-6'>
                              <div className='form-group mb-3'>
                                <label className='form-label'>{t('PurchasePrice')}</label>
                                <Form.Control
                                  autoComplete='off'
                                  className='form-control'
                                  type='number'
                                  min='0'
                                  step='0.01'
                                  name='purchasePrice'
                                  onChange={formik.handleChange}
                                  value={formik.values.purchasePrice}
                                  isInvalid={!!(formik.touched.purchasePrice && formik.errors.purchasePrice)}
                                />
                                <Form.Control.Feedback type='invalid'>
                                  {formik.errors.purchasePrice}
                                </Form.Control.Feedback>
                              </div>
                            </div>
                            <div className='col-xl-6'>
                              <div className='form-group mb-3'>
                                <label className='form-label'>{t('DiscountRate')}</label>
                                <Form.Control
                                  autoComplete='off'
                                  className='form-control'
                                  type='number'
                                  min='0'
                                  max='100'
                                  step='0.01'
                                  name='discountRate'
                                  onChange={formik.handleChange}
                                  value={formik.values.discountRate}
                                  isInvalid={!!(formik.touched.discountRate && formik.errors.discountRate)}
                                />
                                <Form.Control.Feedback type='invalid'>
                                  {formik.errors.discountRate}
                                </Form.Control.Feedback>
                              </div>
                            </div>
                            <div className='col-xl-6'>
                              <div className='form-group mb-3'>
                                <label className='form-label'>{t('UpperDemandLimit')}</label>
                                <Form.Control
                                  autoComplete='off'
                                  className='form-control'
                                  type='number'
                                  min='0'
                                  name='demandTimeUp'
                                  onChange={formik.handleChange}
                                  value={formik.values.demandTimeUp}
                                  isInvalid={!!(formik.touched.demandTimeUp && formik.errors.demandTimeUp)}
                                />
                                <Form.Control.Feedback type='invalid'>
                                  {formik.errors.demandTimeUp}
                                </Form.Control.Feedback>
                              </div>
                            </div>
                            <div className='col-xl-6'>
                              <div className='form-group mb-3'>
                                <label className='form-label'>{t('LowerDemandLimit')}</label>
                                <Form.Control
                                  autoComplete='off'
                                  className='form-control'
                                  type='number'
                                  min='0'
                                  name='demandTimeDown'
                                  onChange={formik.handleChange}
                                  value={formik.values.demandTimeDown}
                                  isInvalid={!!(formik.touched.demandTimeDown && formik.errors.demandTimeDown)}
                                />
                                <Form.Control.Feedback type='invalid'>
                                  {formik.errors.demandTimeDown}
                                </Form.Control.Feedback>
                              </div>
                            </div>

                            <div className='col-xl-6'>
                              <div className='form-group mb-3'>
                                <label className='form-label required-field'>{t('TaxCategory')}</label>
                                <Form.Select
                                  disabled
                                  className='form-select'
                                  name='taxCategory'
                                  onChange={formik.handleChange}
                                  value={formik.values.taxCategory}
                                  isInvalid={!!(formik.touched.taxCategory && formik.errors.taxCategory)}
                                >
                                  {/* <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option> */}
                                  {TaxCategory &&
                                    TaxCategory?.map((item: any, idx: number) =>
                                      item.list?.map((list: any) => (
                                        <option key={++idx} value={list.lookupCode}>
                                          {i18n.language === 'en' ? list.meaning : list.meaning2}
                                        </option>
                                      ))
                                    )}
                                </Form.Select>
                                <Form.Control.Feedback type='invalid'>
                                  {formik.errors.taxCategory}
                                </Form.Control.Feedback>
                              </div>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </div>
                    <div className='col-4'>
                      <div className='col-xl-12'>
                        <Card>
                          <div className='card-header bg-light bg-opacity-30'>
                            <h5 className='mb-0'>
                              <i className='fas fa-cog me-2'></i> {t('ItemSettings')}
                            </h5>
                          </div>
                          <div className='card-body'>
                            <div className='settings-container'>
                              <div className='form-check form-switch mb-3'>
                                <input
                                  type='checkbox'
                                  className='form-check-input'
                                  name='isActive'
                                  checked={formik.values.isActive}
                                  onChange={formik.handleChange}
                                  id='isActiveSwitch'
                                />
                                <label className='form-check-label' htmlFor='isActiveSwitch'>
                                  {t('Active')}
                                </label>
                              </div>

                              {/* <div className='form-check form-switch mb-3'>
                                <input
                                  className='form-check-input'
                                  type='checkbox'
                                  name='serviceItemFlag'
                                  checked={formik.values.serviceItemFlag}
                                  onChange={formik.handleChange}
                                  id='serviceItemSwitch'
                                />
                                <label className='form-check-label' htmlFor='serviceItemSwitch'>
                                  {t('ServiceItem')}
                                </label>
                              </div> */}

                              <div className='form-check form-switch mb-3'>
                                <input
                                  className='form-check-input'
                                  type='checkbox'
                                  name='invTransactionsEnabledFlag'
                                  checked={formik.values.invTransactionsEnabledFlag}
                                  onChange={formik.handleChange}
                                  id='trackInventorySwitch'
                                />
                                <label className='form-check-label' htmlFor='trackInventorySwitch'>
                                  {t('TrackInventory')}
                                </label>
                              </div>

                              <div className='form-check form-switch mb-3'>
                                <input
                                  type='checkbox'
                                  className='form-check-input'
                                  name='customerOrderEnabledFlag'
                                  checked={formik.values.customerOrderEnabledFlag}
                                  onChange={formik.handleChange}
                                  id='customerOrdersSwitch'
                                />
                                <label className='form-check-label' htmlFor='customerOrdersSwitch'>
                                  {t('EnableCustomerOrders')}
                                </label>
                              </div>

                              <div className='form-check form-switch mb-3'>
                                <input
                                  type='checkbox'
                                  className='form-check-input'
                                  name='soTransactionsFlag'
                                  checked={formik.values.soTransactionsFlag}
                                  onChange={formik.handleChange}
                                  id='salesOrdersSwitch'
                                />
                                <label className='form-check-label' htmlFor='salesOrdersSwitch'>
                                  {t('AvailableForSale')}
                                </label>
                              </div>

                              <div className='form-check form-switch mb-3'>
                                <input
                                  type='checkbox'
                                  className='form-check-input'
                                  name='purchasingEnabledFlag'
                                  checked={formik.values.purchasingEnabledFlag}
                                  onChange={formik.handleChange}
                                  id='purchasingSwitch'
                                />
                                <label className='form-check-label' htmlFor='purchasingSwitch'>
                                  {t('EnablePurchasing')}
                                </label>
                              </div>

                              <div className='form-check form-switch mb-3'>
                                <input
                                  type='checkbox'
                                  className='form-check-input'
                                  name='internalOrderEnabledFlag'
                                  checked={formik.values.internalOrderEnabledFlag}
                                  onChange={formik.handleChange}
                                  id='internalOrdersSwitch'
                                />
                                <label className='form-check-label' htmlFor='internalOrdersSwitch'>
                                  {t('InternalTransfer')}
                                </label>
                              </div>

                              <div className='form-check form-switch mb-3'>
                                <input
                                  className='form-check-input'
                                  type='checkbox'
                                  name='authorizeNegativeStock'
                                  checked={formik.values.authorizeNegativeStock}
                                  onChange={formik.handleChange}
                                  id='negativeStockSwitch'
                                />
                                <label className='form-check-label' htmlFor='negativeStockSwitch'>
                                  {t('AllowNegativeStock')}
                                </label>
                              </div>
                            </div>
                          </div>
                        </Card>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {Object.keys(formik.errors).length > 0 && (
              <div className='alert alert-danger mt-3 border rounded-2 shadow-sm' role='alert'>
                <h6 className='mb-1 text-danger'>
                  <i className='bi bi-exclamation-triangle-fill me-2'></i>
                  {i18n.language === 'en' ? 'Please review the following fields:' : '  يُرجى مراجعة الحقول التالية:'}
                </h6>
                <ul className='mb-0 ps-4 mt-2'>
                  {Object.entries(formik.errors).map(([field, error]) => (
                    <li key={field} className='small'>
                      <strong>{fieldNames[field] ?? field}:</strong> <span className='fw-normal'>{error}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </Loading>
        <div className='d-flex justify-content-center mt-4'>
          <button disabled={formik.isSubmitting} type='submit' className='btn btn-theme me-2'>
            {formik.isSubmitting ? (
              <>
                <div className='spinner-border spinner-border-sm me-2'></div>
                {t('Saving')}
              </>
            ) : (
              <>
                <i className='fas fa-save me-2'></i>
                {t('AddItem')}
              </>
            )}
          </button>
          <button type='button' className='btn btn-secondary' onClick={() => onclose()}>
            <i className='fas fa-times me-2'></i>
            {t('Cancel')}
          </button>
        </div>
      </Form>
    </>
  );
};

export default AddMasterItems;

//__________________________________________________________________________________________________

// import { useFormik } from 'formik';
// import { useTranslation } from 'react-i18next';
// import { useAppDispatch } from '@store/hooks';
// import { Form } from 'react-bootstrap';
// import useGetCategoriesList from '@hooks/INV/useGetCategoriesList';
// import { AddMasterItemsINV, GetMasterItemsList, getNewItemBarcode } from '@store/INV/MasterItems/MasterItemsSlice';
// import CustomAlert from '@components/Shared/Alert/CustomAlert';
// import useGetUnitsOfMeasureList from '@hooks/INV/useGetUnitsOfMeasureList';
// import useLookupGetItemType from '@hooks/Lookups/use-Lookup-GetItemType';
// import { MasterItemsSchema, MasterItemsSchema2 } from '../../../ValidationForm/validationSchema';
// import useGetBrandList from '@hooks/INV/Brand/useGetBrandList';
// import Loading from '@components/Shared/Loader/Loading';
// import { useMemo, useState } from 'react';
// import { Card, CardBody } from '@components/card/card';
// import useLookupGetExpenseDistribute from '@hooks/Lookups/use-Lookup-GetExpenseDistribute';
// import useGetTaxCategory from '@hooks/Lookups/use-Get_TaxCategory';

// //__________________________________________________________________________________________________

// const AddMasterItems = ({ onclose }: any) => {
//   const { t, i18n } = useTranslation();
//   const dispatch = useAppDispatch();

//   const [loadBarcode, setLoadBarcode] = useState(false);
//   const { CategoriesList, loading: loading1 } = useGetCategoriesList();
//   const { UnitsOfMeasureList, loading: loading2 } = useGetUnitsOfMeasureList();
//   const { ITEM_TYPE, loading: loading3 } = useLookupGetItemType();
//   const { BrandListOptions, loading: loading4 } = useGetBrandList();
//   const { ExpenseDistribute, loading: loading5 } = useLookupGetExpenseDistribute();
//   const { TaxCategory, loading: loading6 } = useGetTaxCategory();

//   const [activeTab, setActiveTab] = useState<'basic' | 'pricing'>('basic');

//   // ✅ خطوة واجهة: اختيار نوع الصنف أولاً
//   const [step, setStep] = useState<'type' | 'form'>('type');

//   const initialValues = {
//     id: '',
//     itemCode: '',
//     barcode: '',
//     name: '',
//     name2: '',
//     brandId: '',
//     displayName: '',
//     displayName2: '',
//     categoryId: '',
//     itemType: '',
//     isActive: true,
//     purchasingEnabledFlag: false,
//     customerOrderEnabledFlag: false,
//     internalOrderEnabledFlag: false,
//     soTransactionsFlag: false,
//     invTransactionsEnabledFlag: false,
//     authorizeNegativeStock: false,
//     salesPrice: '',
//     purchasePrice: '',
//     unitOfMeasure: '',
//     image: '',
//     demandTimeUp: '0',
//     demandTimeDown: '0',
//     description: '',
//     discountRate: '0',
//     expenseDistribute: '',
//     taxCategory: ''
//   };

//   const formik = useFormik({
//     initialValues,
//     // validationSchema: MasterItemsSchema(t),
//     validationSchema: MasterItemsSchema2(t),
//     onSubmit: values => {
//       dispatch(
//         AddMasterItemsINV({
//           id: null,
//           itemCode: values.itemCode,
//           barcode: values.barcode,
//           name: values.name,
//           name2: values.name2,
//           displayName: values.displayName,
//           displayName2: values.displayName2,
//           categoryId: values.categoryId,
//           brandId: values.brandId || null,
//           itemType: values.itemType,
//           isActive: values.isActive,
//           purchasingEnabledFlag: values.purchasingEnabledFlag,
//           customerOrderEnabledFlag: values.customerOrderEnabledFlag,
//           internalOrderEnabledFlag: values.internalOrderEnabledFlag,
//           soTransactionsFlag: values.soTransactionsFlag,
//           invTransactionsEnabledFlag: values.invTransactionsEnabledFlag,
//           authorizeNegativeStock: values.authorizeNegativeStock,
//           salesPrice: values.salesPrice || 0,
//           purchasePrice: values.purchasePrice || 0,
//           unitOfMeasure: values.unitOfMeasure,
//           image: values.image,
//           demandTimeUp: values.demandTimeUp || 0,
//           demandTimeDown: values.demandTimeDown || 0,
//           description: values.description,
//           discountRate: values.discountRate || 0,
//           taxCategory: values.taxCategory,
//           expenseDistribute: values.itemType === 'ExpenseItem' ? values.expenseDistribute : ''
//         })
//       )
//         .unwrap()
//         .then(res => {
//           if (res.succeeded === true) {
//             dispatch(GetMasterItemsList());
//             CustomAlert({ action: 'Add' });
//             onclose();
//           } else {
//             CustomAlert({ action: 'Error' });
//           }
//         })
//         .catch(() => {
//           CustomAlert({ action: 'Error' });
//         })
//         .finally(() => formik.setSubmitting(false));
//     }
//   });

//   // دالة توليد باركود من السيرفر
//   const generateBarcode = async () => {
//     try {
//       setLoadBarcode(true);
//       const res = await dispatch(getNewItemBarcode()).unwrap();
//       if (res.succeeded === true) {
//         formik.setFieldValue('barcode', res.data);
//       } else {
//         formik.setFieldValue('barcode', '0');
//       }
//     } catch {
//       formik.setFieldValue('barcode', '0');
//     } finally {
//       setLoadBarcode(false);
//     }
//   };

//   // ✅ تجهيز خيارات أنواع الأصناف من lookup (Flatten + unique)
//   const itemTypeOptions = useMemo(() => {
//     const all: Array<{ code: string; labelEn: string; labelAr: string }> = [];
//     ITEM_TYPE?.forEach((g: any) => {
//       g.list?.forEach((l: any) => {
//         all.push({
//           code: l.lookupCode,
//           labelEn: l.meaning,
//           labelAr: l.meaning2
//         });
//       });
//     });

//     const map = new Map<string, { code: string; labelEn: string; labelAr: string }>();
//     all.forEach(x => {
//       if (!map.has(x.code)) map.set(x.code, x);
//     });
//     return Array.from(map.values());
//   }, [ITEM_TYPE]);

//   const getTypeLabel = (code: string) => {
//     const f = itemTypeOptions.find(x => x.code === code);
//     if (!f) return code || '';
//     return i18n.language === 'ar' ? f.labelAr : f.labelEn;
//   };

//   // ✅ ميتاداتا للكروت (أي نوع غير معروف يأخذ افتراضي)
//   // ✅ ميتاداتا للكروت حسب أنواع الأصناف عندكم
//   const TYPE_META: Record<string, { icon: string; descAr?: string; descEn?: string }> = {
//     InventoryItem: {
//       icon: 'fas fa-warehouse',
//       descAr: 'صنف مخزني: يُخزّن ويُباع/يُشترى مع تتبع كميات المخزون',
//       descEn: 'Inventory item: stocked, bought/sold with inventory quantity tracking'
//     },

//     ServiceItem: {
//       icon: 'fas fa-concierge-bell',
//       descAr: 'صنف خدمي: خدمة بدون مخزون (عادة يُستخدم في المبيعات)',
//       descEn: 'Service item: non-stock service (typically used in sales)'
//     },

//     ExpenseItem: {
//       icon: 'fas fa-file-invoice-dollar',
//       descAr: 'صنف مصروف: بند مصروفات للتسجيل/التوزيع بدون مخزون وأسعار ثابتة',
//       descEn: 'Expense item: expense/distribution entry with no inventory and no fixed prices'
//     },

//     FixedAssetItem: {
//       icon: 'fas fa-building',
//       descAr: 'صنف أصل ثابت: يُستخدم لتكوين أصول ثابتة ثم الإهلاك (ليس للبيع عادة)',
//       descEn: 'Fixed asset item: used to capitalize fixed assets then depreciate (not typically for sale)'
//     },

//     AssemblyItem: {
//       icon: 'fas fa-cubes',
//       descAr: 'صنف تجميعي: منتج نهائي يُجمّع من مكونات (BOM) وله مخزون مستقل بعد التجميع',
//       descEn: 'Assembly item: final product built from BOM components with its own stock after assembly'
//     }
//   };

//   const DEFAULT_META = {
//     icon: 'fas fa-cube',
//     descAr: '',
//     descEn: ''
//   };

//   const isExpense = formik.values.itemType === 'ExpenseItem';

//   // ✅ إخفاء/إظهار حقول حسب النوع (عدّلها لاحقاً حسب قواعدك)
//   const isFieldVisible = (field: string) => {
//     if (!isExpense) return true;
//     // ExpenseItem: أخفي حقول التسعير والحدود والخصم
//     const hiddenForExpense = ['salesPrice', 'purchasePrice', 'discountRate', 'demandTimeUp', 'demandTimeDown'];
//     return !hiddenForExpense.includes(field);
//   };

//   const isSwitchVisible = (name: string) => {
//     if (!isExpense) return true;
//     // ExpenseItem: أخفي السويتشات غير المناسبة
//     const hidden = [
//       'invTransactionsEnabledFlag',
//       'customerOrderEnabledFlag',
//       'soTransactionsFlag',
//       'internalOrderEnabledFlag',
//       'authorizeNegativeStock'
//     ];
//     return !hidden.includes(name);
//   };

//   // ✅ عند اختيار النوع: ضع Defaults مناسبة (هنا ركزت على ExpenseItem)
//   const chooseType = async (code: string) => {
//     formik.setFieldValue('itemType', code);

//     if (code === 'ExpenseItem') {
//       // Defaults منطقية للمصروف
//       formik.setFieldValue('salesPrice', '');
//       formik.setFieldValue('purchasePrice', '');
//       formik.setFieldValue('discountRate', '0');
//       formik.setFieldValue('demandTimeUp', '0');
//       formik.setFieldValue('demandTimeDown', '0');

//       formik.setFieldValue('invTransactionsEnabledFlag', false);
//       formik.setFieldValue('customerOrderEnabledFlag', false);
//       formik.setFieldValue('soTransactionsFlag', false);
//       formik.setFieldValue('internalOrderEnabledFlag', false);
//       formik.setFieldValue('authorizeNegativeStock', false);

//       // غالباً المصروف له مشتريات
//       formik.setFieldValue('purchasingEnabledFlag', true);
//     }

//     setActiveTab('basic');
//     setStep('form');
//   };

//   const fieldNames: Record<string, string> = {
//     name2: t('LocalName'),
//     purchasePrice: t('PurchasePrice'),
//     salesPrice: t('SalesPrice'),
//     name: t('GlobalName'),
//     itemCode: t('ItemCode'),
//     categoryId: t('ItemCategory'),
//     barcode: t('Barcode'),
//     itemType: t('ItemType'),
//     unitOfMeasure: t('UnitOfMeasure'),
//     demandTimeUp: t('UpperDemandLimit'),
//     demandTimeDown: t('LowerDemandLimit'),
//     expenseDistribute: t('DistributionMethod'),
//     taxCategory: t('TaxCategory'),
//     discountRate: t('DiscountRate')
//   };

//   // ✅ فلترة رسائل الأخطاء حسب الحقول المرئية (عشان ما يطلع لك أخطاء لحقول مخفية)
//   const visibleErrors = useMemo(() => {
//     return Object.entries(formik.errors).filter(([field]) => isFieldVisible(field));
//   }, [formik.errors, isExpense]);

//   return (
//     <>
//       <Loading loading={loading1 || loading2 || loading3 || loading4 || loading5 || loading6}>
//         <Form onSubmit={formik.handleSubmit}>
//           <Card className='mb-0 p-3 shadow-sm'>
//             <div className='d-flex align-items-start justify-content-between gap-2'>
//               <div>
//                 <h4>
//                   <i className='fas fa-cube me-2 text-theme'></i> {t('AddNewItem')}
//                 </h4>
//                 <p className='mb-0'>{t('FillBasicItemDataToAddToInventory')}</p>
//               </div>

//               {step === 'form' && (
//                 <button
//                   type='button'
//                   className='btn btn-outline-secondary'
//                   onClick={() => setStep('type')}
//                   title={i18n.language === 'ar' ? 'تغيير نوع الصنف' : 'Change item type'}
//                 >
//                   <i className='fas fa-exchange-alt me-2'></i>
//                   {i18n.language === 'ar' ? 'تغيير النوع' : 'Change type'}
//                 </button>
//               )}
//             </div>
//           </Card>

//           <div className='p-3'>
//             {/* ✅ STEP 1: اختيار نوع الصنف بالكروت */}
//             {step === 'type' && (
//               <Card className='shadow-sm'>
//                 <div className='card-header bg-light bg-opacity-30'>
//                   <h5 className='mb-0'>
//                     <i className='fas fa-th-large me-2'></i>
//                     {i18n.language === 'ar' ? 'اختر نوع الصنف' : 'Choose item type'}
//                   </h5>
//                 </div>
//                 <CardBody>
//                   <div className='row g-3'>
//                     {itemTypeOptions.map(opt => {
//                       const meta = TYPE_META[opt.code] ?? DEFAULT_META;
//                       const title = i18n.language === 'ar' ? opt.labelAr : opt.labelEn;
//                       const desc = i18n.language === 'ar' ? meta.descAr : meta.descEn;

//                       return (
//                         <div className='col-md-6 col-lg-4' key={opt.code}>
//                           <Card>
//                             <button
//                               type='button'
//                               className='card w-100 text-start shadow-sm '
//                               style={{ cursor: 'pointer' }}
//                               onClick={() => chooseType(opt.code)}
//                             >
//                               <div className='card-body'>
//                                 <div className='d-flex align-items-start'>
//                                   <div className='me-3 mt-1'>
//                                     <i className={`${meta.icon} fs-2 text-theme`}></i>
//                                   </div>
//                                   <div className='flex-grow-1'>
//                                     <div className='fw-bold'>{title}</div>
//                                     {!!desc && <div className='text-muted small mt-1'>{desc}</div>}
//                                   </div>
//                                 </div>
//                               </div>
//                             </button>
//                           </Card>
//                         </div>
//                       );
//                     })}
//                   </div>

//                   <div className='d-flex justify-content-center mt-4'>
//                     <button type='button' className='btn btn-secondary' onClick={() => onclose()}>
//                       <i className='fas fa-times me-2'></i>
//                       {t('Cancel')}
//                     </button>
//                   </div>
//                 </CardBody>
//               </Card>
//             )}

//             {/* ✅ STEP 2: النموذج بعد اختيار النوع */}
//             {step === 'form' && (
//               <>
//                 <ul className='nav nav-tabs mb-4' role='tablist'>
//                   <li className='nav-item'>
//                     <button
//                       className={`nav-link ${activeTab === 'basic' ? 'active' : ''}`}
//                       onClick={() => setActiveTab('basic')}
//                       type='button'
//                     >
//                       <i className='fas fa-info-circle me-2'></i>
//                       {t('BasicInformation')}
//                     </button>
//                   </li>

//                   <li className='nav-item'>
//                     <button
//                       className={`nav-link ${activeTab === 'pricing' ? 'active' : ''}`}
//                       onClick={() => setActiveTab('pricing')}
//                       type='button'
//                     >
//                       <i className='fas fa-cog me-2'></i> {t('ItemSettings')}
//                     </button>
//                   </li>
//                 </ul>

//                 <div className='row'>
//                   <div className='col-xl-12'>
//                     {/* BASIC TAB */}
//                     <div className={`tab-pane ${activeTab === 'basic' ? 'show active' : 'd-none'}`}>
//                       <Card>
//                         <div className='card-header bg-light bg-opacity-30'>
//                           <h5 className='mb-0'>
//                             <i className='fas fa-info-circle me-2'></i>
//                             {t('BasicInformation')}
//                           </h5>
//                         </div>

//                         <CardBody>
//                           <div className='row'>
//                             <div className='col-xl-6'>
//                               <div className='form-group mb-3'>
//                                 <label className='form-label required-field'>{t('LocalName')}</label>
//                                 <Form.Control
//                                   autoComplete='off'
//                                   className='form-control'
//                                   type='text'
//                                   name='name2'
//                                   onChange={formik.handleChange}
//                                   value={formik.values.name2}
//                                   isInvalid={!!(formik.touched.name2 && formik.errors.name2)}
//                                   placeholder={t('EnterLocalName')}
//                                 />
//                                 <Form.Control.Feedback type='invalid'>{formik.errors.name2}</Form.Control.Feedback>
//                               </div>
//                             </div>

//                             <div className='col-xl-6'>
//                               <div className='form-group mb-3'>
//                                 <label className='form-label required-field'>{t('GlobalName')}</label>
//                                 <Form.Control
//                                   autoComplete='off'
//                                   className='form-control'
//                                   type='text'
//                                   name='name'
//                                   onChange={formik.handleChange}
//                                   value={formik.values.name}
//                                   isInvalid={!!(formik.touched.name && formik.errors.name)}
//                                   placeholder={t('EnterGlobalName')}
//                                 />
//                                 <Form.Control.Feedback type='invalid'>{formik.errors.name}</Form.Control.Feedback>
//                               </div>
//                             </div>

//                             <div className='col-xl-6'>
//                               <label className='form-label'>{t('Barcode')}</label>
//                               <div className='input-group flex-nowrap'>
//                                 <span className='input-group-text'>
//                                   <i className='fas fa-barcode'></i>
//                                 </span>
//                                 <Form.Control
//                                   autoComplete='off'
//                                   className='form-control'
//                                   type='text'
//                                   name='barcode'
//                                   onChange={formik.handleChange}
//                                   value={formik.values.barcode}
//                                   isInvalid={!!(formik.touched.barcode && formik.errors.barcode)}
//                                   placeholder={t('EnterBarcode')}
//                                 />

//                                 <button
//                                   type='button'
//                                   className='btn btn-outline-secondary'
//                                   onClick={generateBarcode}
//                                   title={t('GenerateBarcode')}
//                                 >
//                                   {loadBarcode ? (
//                                     <div className='spinner-border spinner-border-sm'></div>
//                                   ) : (
//                                     <i className='fa fa-magic'></i>
//                                   )}
//                                 </button>
//                               </div>
//                             </div>

//                             <div className='col-xl-6'>
//                               <div className='form-group mb-3'>
//                                 <label className='form-label required-field'>{t('ItemCode')}</label>
//                                 <Form.Control
//                                   autoComplete='off'
//                                   className='form-control'
//                                   type='text'
//                                   name='itemCode'
//                                   onChange={formik.handleChange}
//                                   value={formik.values.itemCode}
//                                   isInvalid={!!(formik.touched.itemCode && formik.errors.itemCode)}
//                                   placeholder={t('EnterItemCode')}
//                                 />
//                                 <Form.Control.Feedback type='invalid'>{formik.errors.itemCode}</Form.Control.Feedback>
//                               </div>
//                             </div>

//                             <div className='col-xl-6'>
//                               <div className='form-group mb-3'>
//                                 <label className='form-label required-field'>{t('ItemCategory')}</label>
//                                 <Form.Select
//                                   className='form-select'
//                                   name='categoryId'
//                                   onChange={formik.handleChange}
//                                   value={formik.values.categoryId}
//                                   isInvalid={!!(formik.touched.categoryId && formik.errors.categoryId)}
//                                 >
//                                   <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
//                                   {CategoriesList &&
//                                     CategoriesList?.map((item, idx) => (
//                                       <option key={++idx} value={item.id}>
//                                         {i18n.language === 'en' ? item.name : item.name2}
//                                       </option>
//                                     ))}
//                                 </Form.Select>
//                                 <Form.Control.Feedback type='invalid'>{formik.errors.categoryId}</Form.Control.Feedback>
//                               </div>
//                             </div>

//                             <div className='col-xl-6'>
//                               <div className='form-group mb-3'>
//                                 <label className='form-label'>{t('Brand')}</label>
//                                 <Form.Select
//                                   className='form-select'
//                                   name='brandId'
//                                   onChange={formik.handleChange}
//                                   value={formik.values.brandId}
//                                   isInvalid={!!(formik.touched.brandId && formik.errors.brandId)}
//                                 >
//                                   <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
//                                   {BrandListOptions &&
//                                     BrandListOptions?.map((item, idx) => (
//                                       <option key={++idx} value={item.value}>
//                                         {item.label}
//                                       </option>
//                                     ))}
//                                 </Form.Select>
//                                 <Form.Control.Feedback type='invalid'>{formik.errors.brandId}</Form.Control.Feedback>
//                               </div>
//                             </div>

//                             <div className='col-xl-6'>
//                               <div className='form-group mb-3'>
//                                 <label className='form-label required-field'>{t('UnitOfMeasure')}</label>
//                                 <Form.Select
//                                   className='form-select'
//                                   name='unitOfMeasure'
//                                   onChange={formik.handleChange}
//                                   value={formik.values.unitOfMeasure}
//                                   isInvalid={!!(formik.touched.unitOfMeasure && formik.errors.unitOfMeasure)}
//                                 >
//                                   <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
//                                   {UnitsOfMeasureList &&
//                                     UnitsOfMeasureList?.map((item, idx) => (
//                                       <option key={++idx} value={item.id}>
//                                         {i18n.language === 'en' ? item.name : item.name2}
//                                       </option>
//                                     ))}
//                                 </Form.Select>
//                                 <Form.Control.Feedback type='invalid'>
//                                   {formik.errors.unitOfMeasure}
//                                 </Form.Control.Feedback>
//                               </div>
//                             </div>

//                             {/* ✅ ItemType أصبح Readonly + زر تغيير النوع */}
//                             <div className={formik.values.itemType === 'ExpenseItem' ? 'col-xl-3' : 'col-xl-6'}>
//                               <div className='form-group mb-3'>
//                                 <label className='form-label required-field'>{t('ItemType')}</label>
//                                 <div className='d-flex gap-2 align-items-center'>
//                                   <div className='form-control bg-light'>
//                                     {getTypeLabel(formik.values.itemType) ||
//                                       (i18n.language === 'ar' ? 'غير محدد' : 'Not selected')}
//                                   </div>
//                                   <button
//                                     type='button'
//                                     className='btn btn-outline-secondary'
//                                     onClick={() => setStep('type')}
//                                   >
//                                     <i className='fas fa-exchange-alt me-2'></i>
//                                     {i18n.language === 'ar' ? 'تغيير' : 'Change'}
//                                   </button>
//                                 </div>
//                                 {formik.touched.itemType && formik.errors.itemType && (
//                                   <div className='invalid-feedback d-block'>{formik.errors.itemType as any}</div>
//                                 )}
//                               </div>
//                             </div>

//                             {formik.values.itemType === 'ExpenseItem' && (
//                               <div className='col-xl-3'>
//                                 <div className='form-group mb-3'>
//                                   <label className='form-label required-field'>{t('DistributionMethod')}</label>
//                                   <Form.Select
//                                     className='form-select'
//                                     name='expenseDistribute'
//                                     onChange={formik.handleChange}
//                                     value={formik.values.expenseDistribute}
//                                     isInvalid={!!(formik.touched.expenseDistribute && formik.errors.expenseDistribute)}
//                                   >
//                                     <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
//                                     {ExpenseDistribute &&
//                                       ExpenseDistribute?.map((item: any, idx: number) =>
//                                         item.list?.map((list: any) => (
//                                           <option key={++idx} value={list.lookupCode}>
//                                             {i18n.language === 'ar' ? list.meaning2 : list.meaning}
//                                           </option>
//                                         ))
//                                       )}
//                                   </Form.Select>
//                                   <Form.Control.Feedback type='invalid'>
//                                     {formik.errors.expenseDistribute as any}
//                                   </Form.Control.Feedback>
//                                 </div>
//                               </div>
//                             )}
//                           </div>
//                         </CardBody>
//                       </Card>
//                     </div>

//                     {/* SETTINGS / PRICING TAB */}
//                     <div className={`tab-pane ${activeTab === 'pricing' ? 'show active' : 'd-none'}`}>
//                       <div className='row'>
//                         <div className='col-8'>
//                           <Card>
//                             <div className='card-header bg-light bg-opacity-30'>
//                               <h5 className='mb-0'>
//                                 <i className='fas fa-tag me-2'></i>
//                                 {t('Pricing')}
//                               </h5>
//                             </div>

//                             <CardBody>
//                               <div className='row'>
//                                 {isFieldVisible('salesPrice') && (
//                                   <div className='col-xl-6'>
//                                     <div className='form-group mb-3'>
//                                       <label className='form-label'>{t('SalesPrice')}</label>
//                                       <Form.Control
//                                         autoComplete='off'
//                                         className='form-control'
//                                         type='number'
//                                         min='0'
//                                         step='0.01'
//                                         name='salesPrice'
//                                         onChange={formik.handleChange}
//                                         value={formik.values.salesPrice}
//                                         isInvalid={!!(formik.touched.salesPrice && formik.errors.salesPrice)}
//                                       />
//                                       <Form.Control.Feedback type='invalid'>
//                                         {formik.errors.salesPrice as any}
//                                       </Form.Control.Feedback>
//                                     </div>
//                                   </div>
//                                 )}

//                                 {isFieldVisible('purchasePrice') && (
//                                   <div className='col-xl-6'>
//                                     <div className='form-group mb-3'>
//                                       <label className='form-label'>{t('PurchasePrice')}</label>
//                                       <Form.Control
//                                         autoComplete='off'
//                                         className='form-control'
//                                         type='number'
//                                         min='0'
//                                         step='0.01'
//                                         name='purchasePrice'
//                                         onChange={formik.handleChange}
//                                         value={formik.values.purchasePrice}
//                                         isInvalid={!!(formik.touched.purchasePrice && formik.errors.purchasePrice)}
//                                       />
//                                       <Form.Control.Feedback type='invalid'>
//                                         {formik.errors.purchasePrice as any}
//                                       </Form.Control.Feedback>
//                                     </div>
//                                   </div>
//                                 )}

//                                 {isFieldVisible('discountRate') && (
//                                   <div className='col-xl-6'>
//                                     <div className='form-group mb-3'>
//                                       <label className='form-label'>{t('DiscountRate')}</label>
//                                       <Form.Control
//                                         autoComplete='off'
//                                         className='form-control'
//                                         type='number'
//                                         min='0'
//                                         max='100'
//                                         step='0.01'
//                                         name='discountRate'
//                                         onChange={formik.handleChange}
//                                         value={formik.values.discountRate}
//                                         isInvalid={!!(formik.touched.discountRate && formik.errors.discountRate)}
//                                       />
//                                       <Form.Control.Feedback type='invalid'>
//                                         {formik.errors.discountRate as any}
//                                       </Form.Control.Feedback>
//                                     </div>
//                                   </div>
//                                 )}

//                                 {isFieldVisible('demandTimeUp') && (
//                                   <div className='col-xl-6'>
//                                     <div className='form-group mb-3'>
//                                       <label className='form-label'>{t('UpperDemandLimit')}</label>
//                                       <Form.Control
//                                         autoComplete='off'
//                                         className='form-control'
//                                         type='number'
//                                         min='0'
//                                         name='demandTimeUp'
//                                         onChange={formik.handleChange}
//                                         value={formik.values.demandTimeUp}
//                                         isInvalid={!!(formik.touched.demandTimeUp && formik.errors.demandTimeUp)}
//                                       />
//                                       <Form.Control.Feedback type='invalid'>
//                                         {formik.errors.demandTimeUp as any}
//                                       </Form.Control.Feedback>
//                                     </div>
//                                   </div>
//                                 )}

//                                 {isFieldVisible('demandTimeDown') && (
//                                   <div className='col-xl-6'>
//                                     <div className='form-group mb-3'>
//                                       <label className='form-label'>{t('LowerDemandLimit')}</label>
//                                       <Form.Control
//                                         autoComplete='off'
//                                         className='form-control'
//                                         type='number'
//                                         min='0'
//                                         name='demandTimeDown'
//                                         onChange={formik.handleChange}
//                                         value={formik.values.demandTimeDown}
//                                         isInvalid={!!(formik.touched.demandTimeDown && formik.errors.demandTimeDown)}
//                                       />
//                                       <Form.Control.Feedback type='invalid'>
//                                         {formik.errors.demandTimeDown as any}
//                                       </Form.Control.Feedback>
//                                     </div>
//                                   </div>
//                                 )}

//                                 {/* ✅ TaxCategory (موجود للجميع) */}
//                                 <div className='col-xl-6'>
//                                   <div className='form-group mb-3'>
//                                     <label className='form-label required-field'>{t('TaxCategory')}</label>
//                                     <Form.Select
//                                       className='form-select'
//                                       name='taxCategory'
//                                       onChange={formik.handleChange}
//                                       value={formik.values.taxCategory}
//                                       isInvalid={!!(formik.touched.taxCategory && formik.errors.taxCategory)}
//                                     >
//                                       <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
//                                       {TaxCategory &&
//                                         TaxCategory?.map((item: any, idx: number) =>
//                                           item.list?.map((list: any) => (
//                                             <option key={++idx} value={list.lookupCode}>
//                                               {i18n.language === 'en' ? list.meaning : list.meaning2}
//                                             </option>
//                                           ))
//                                         )}
//                                     </Form.Select>
//                                     <Form.Control.Feedback type='invalid'>
//                                       {formik.errors.taxCategory as any}
//                                     </Form.Control.Feedback>
//                                   </div>
//                                 </div>
//                               </div>

//                               {isExpense && (
//                                 <div className='alert alert-info mb-0'>
//                                   {i18n.language === 'ar'
//                                     ? 'صنف المصروفات لا يحتاج أسعار بيع/شراء أو حدود الطلب.'
//                                     : 'Expense items do not require sales/purchase prices or demand limits.'}
//                                 </div>
//                               )}
//                             </CardBody>
//                           </Card>
//                         </div>

//                         <div className='col-4'>
//                           <div className='col-xl-12'>
//                             <Card>
//                               <div className='card-header bg-light bg-opacity-30'>
//                                 <h5 className='mb-0'>
//                                   <i className='fas fa-cog me-2'></i> {t('ItemSettings')}
//                                 </h5>
//                               </div>

//                               <div className='card-body'>
//                                 <div className='settings-container'>
//                                   {/* Active */}
//                                   <div className='form-check form-switch mb-3'>
//                                     <input
//                                       type='checkbox'
//                                       className='form-check-input'
//                                       name='isActive'
//                                       checked={formik.values.isActive}
//                                       onChange={formik.handleChange}
//                                       id='isActiveSwitch'
//                                     />
//                                     <label className='form-check-label' htmlFor='isActiveSwitch'>
//                                       {t('Active')}
//                                     </label>
//                                   </div>

//                                   {/* Track Inventory */}
//                                   {isSwitchVisible('invTransactionsEnabledFlag') && (
//                                     <div className='form-check form-switch mb-3'>
//                                       <input
//                                         className='form-check-input'
//                                         type='checkbox'
//                                         name='invTransactionsEnabledFlag'
//                                         checked={formik.values.invTransactionsEnabledFlag}
//                                         onChange={formik.handleChange}
//                                         id='trackInventorySwitch'
//                                       />
//                                       <label className='form-check-label' htmlFor='trackInventorySwitch'>
//                                         {t('TrackInventory')}
//                                       </label>
//                                     </div>
//                                   )}

//                                   {/* Enable Customer Orders */}
//                                   {isSwitchVisible('customerOrderEnabledFlag') && (
//                                     <div className='form-check form-switch mb-3'>
//                                       <input
//                                         type='checkbox'
//                                         className='form-check-input'
//                                         name='customerOrderEnabledFlag'
//                                         checked={formik.values.customerOrderEnabledFlag}
//                                         onChange={formik.handleChange}
//                                         id='customerOrdersSwitch'
//                                       />
//                                       <label className='form-check-label' htmlFor='customerOrdersSwitch'>
//                                         {t('EnableCustomerOrders')}
//                                       </label>
//                                     </div>
//                                   )}

//                                   {/* Available For Sale */}
//                                   {isSwitchVisible('soTransactionsFlag') && (
//                                     <div className='form-check form-switch mb-3'>
//                                       <input
//                                         type='checkbox'
//                                         className='form-check-input'
//                                         name='soTransactionsFlag'
//                                         checked={formik.values.soTransactionsFlag}
//                                         onChange={formik.handleChange}
//                                         id='salesOrdersSwitch'
//                                       />
//                                       <label className='form-check-label' htmlFor='salesOrdersSwitch'>
//                                         {t('AvailableForSale')}
//                                       </label>
//                                     </div>
//                                   )}

//                                   {/* Enable Purchasing (مفيد حتى للمصروف) */}
//                                   <div className='form-check form-switch mb-3'>
//                                     <input
//                                       type='checkbox'
//                                       className='form-check-input'
//                                       name='purchasingEnabledFlag'
//                                       checked={formik.values.purchasingEnabledFlag}
//                                       onChange={formik.handleChange}
//                                       id='purchasingSwitch'
//                                     />
//                                     <label className='form-check-label' htmlFor='purchasingSwitch'>
//                                       {t('EnablePurchasing')}
//                                     </label>
//                                   </div>

//                                   {/* Internal Transfer */}
//                                   {isSwitchVisible('internalOrderEnabledFlag') && (
//                                     <div className='form-check form-switch mb-3'>
//                                       <input
//                                         type='checkbox'
//                                         className='form-check-input'
//                                         name='internalOrderEnabledFlag'
//                                         checked={formik.values.internalOrderEnabledFlag}
//                                         onChange={formik.handleChange}
//                                         id='internalOrdersSwitch'
//                                       />
//                                       <label className='form-check-label' htmlFor='internalOrdersSwitch'>
//                                         {t('InternalTransfer')}
//                                       </label>
//                                     </div>
//                                   )}

//                                   {/* Allow Negative Stock */}
//                                   {isSwitchVisible('authorizeNegativeStock') && (
//                                     <div className='form-check form-switch mb-3'>
//                                       <input
//                                         className='form-check-input'
//                                         type='checkbox'
//                                         name='authorizeNegativeStock'
//                                         checked={formik.values.authorizeNegativeStock}
//                                         onChange={formik.handleChange}
//                                         id='negativeStockSwitch'
//                                       />
//                                       <label className='form-check-label' htmlFor='negativeStockSwitch'>
//                                         {t('AllowNegativeStock')}
//                                       </label>
//                                     </div>
//                                   )}
//                                 </div>
//                               </div>
//                             </Card>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Errors summary */}
//                 {visibleErrors.length > 0 && (
//                   <div className='alert alert-danger mt-3 border rounded-2 shadow-sm' role='alert'>
//                     <h6 className='mb-1 text-danger'>
//                       <i className='bi bi-exclamation-triangle-fill me-2'></i>
//                       {i18n.language === 'en'
//                         ? 'Please review the following fields:'
//                         : '  يُرجى مراجعة الحقول التالية:'}
//                     </h6>
//                     <ul className='mb-0 ps-4 mt-2'>
//                       {visibleErrors.map(([field, error]) => (
//                         <li key={field} className='small'>
//                           <strong>{fieldNames[field] ?? field}:</strong>{' '}
//                           <span className='fw-normal'>{error as any}</span>
//                         </li>
//                       ))}
//                     </ul>
//                   </div>
//                 )}

//                 <div className='d-flex justify-content-center mt-4'>
//                   <button disabled={formik.isSubmitting} type='submit' className='btn btn-theme me-2'>
//                     {formik.isSubmitting ? (
//                       <>
//                         <div className='spinner-border spinner-border-sm me-2'></div>
//                         {t('Saving')}
//                       </>
//                     ) : (
//                       <>
//                         <i className='fas fa-save me-2'></i>
//                         {t('AddItem')}
//                       </>
//                     )}
//                   </button>
//                   <button type='button' className='btn btn-secondary' onClick={() => onclose()}>
//                     <i className='fas fa-times me-2'></i>
//                     {t('Cancel')}
//                   </button>
//                 </div>
//               </>
//             )}
//           </div>
//         </Form>
//       </Loading>
//     </>
//   );
// };

// export default AddMasterItems;
